// A worksheet can be submitted only when its first page loaded with answers.
export const canSubmitWorksheet = (workSheetData) =>
  Boolean(workSheetData?.[0]?.properties?.answers);
